<template>
    <iframe :style="'color:red;width:100%;'+'height:'+getHeigth()" :src="bigUrl" frameborder="0" scrolling="no">

    </iframe>
</template>

<script>
    export default {
        name: "data_big",
        data() {
          return {
            bigUrl: "https://charts.thingjs.com/kunpeng/preview/sandbox/0e0cdf9c06a94a128d4069054eab8f71",
          }
        },
        methods:{
          getHeigth(){
            return window.innerHeight+"px"
          }
        }
    }
</script>

<style scoped>
  body {
    background: #ffffff;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/data_big.vue